// import { getMediaUrl, getUrlResource } from '@/shared/_api'
import { getResourceFromAws, getThumbnail } from '../../../shared/_api'

export default {
  data () {
    return {
      fetchedResourceBig: null
    }
  },
  computed: {
    asyncImage () {
      return {
        content: this.getBigImage,
        loadingContent: `<div class="py-4">
          <div
            class="text-primary spinner-border"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
        </div>`,
        html: true,
        classes: ['vue-tooltip-theme', 'tooltip-big-image']
      }
    }
  },
  methods: {
    getStyle (resource) {
      if (resource) {
        return {
          backgroundImage: `url(${resource})`
        }
      }
      return {}
    },
    async fetchImage () {
      if (this.resourceId) {
        if (this.downloading) return
        this.downloading = true
        try {
          const fetchedResource = await getResourceFromAws(this.resourceId)
          await this.fileTypeHandler(
            fetchedResource.data,
            fetchedResource.data.type
          )
        } catch (error) {
          console.error('Fetch Image error', error)
        } finally {
          this.downloading = false
        }
      } else if (this.file) {
        this.downloading = true
        await this.fileTypeHandler(this.file, this.file.type)
        this.downloading = false
      }
    },
    async fetchSmallThumbnail () {
      try {
        const fetchedResource = await getThumbnail(this.resourceId, 'small')
        return fetchedResource.data
      } catch (error) {
        console.error('Fetch Image error', error)
        return require('@/assets/img/pdf.png')
      }
    },
    async fetchBigThumbnail (resourceId) {
      try {
        const fetchedResource = await getThumbnail(this.resourceId || resourceId, 'big')
        return fetchedResource.data
      } catch (error) {
        console.error('Fetch Image error', error)
        return require('@/assets/img/pdf.png')
      }
    },
    async fileTypeHandler (resource, type) {
      if (resource && type) {
        this.fetchedResource = URL.createObjectURL(resource)
        this.resourceType = type
      }
    },
    async getBigImage () {
      if (this.file) {
        this.fetchedResourceBig = URL.createObjectURL(this.file)
      } else {
        this.fetchedResourceBig = await this.fetchBigThumbnail(this.resourceId || this.transaction.receipt.receiptMedia[(this.transaction.receipt.receiptMedia.length - 1)].media.id)
      }
      return `<div
          class="image-big"
          style="background-image: url(${this.fetchedResourceBig}), url(${require('@/assets/img/pdf.png')})"
        ></div>`
    }
  }
}
